document.addEventListener('DOMContentLoaded', () => {
  class FeaturedProduct extends HTMLElement {
      constructor() {
          super();

          this.mainSlider = null;
          this.thumbnailsSlider = null;
          this.mainGallery = this.querySelector('.product-media__main-slider.swiper') || null;
          this.thumbnailsGallery = this.querySelector('.product-media__thumbnails-slider.swiper') || null;
          this.purchaseSelectors = this.querySelectorAll('input[name="current_purchase_type"]');
          this.sellingPlanInput = this.querySelector('[name="selling_plan"]') || null;
          this.productForm = this.querySelector('product-form form') || null;
          this.submitButton = this.querySelector('.product-form__submit') || null;
      }
  
      connectedCallback() {
          this.initGallery();
          this.setPurchaseTypeSelectorsListener();
          this.setSubmitListener();
      }
  
      initGallery() {
          if (!this.mainGallery || typeof window.Swiper === 'undefined') return;
  
          this.thumbnailsSlider = new Swiper(this.thumbnailsGallery, this.getGalleryConfig('thumbnails'))
          this.mainSlider = new Swiper(this.mainGallery, this.getGalleryConfig('main'))

          this.thumbnailsSlider.slides.forEach(slide => {
              slide.addEventListener('click', (event) => this.onThumbnailClick(event, slide))
          })
      }

      setPurchaseTypeSelectorsListener() {
         this.purchaseSelectors.forEach(selector => {
          selector.addEventListener('change', (event) => this.onPurhaseTypeChange(event))
         })
      }

      setSubmitListener() {
          if (!this.submitButton || !this.productForm) return;

          this.submitButton.addEventListener('click', (event) => {this.onSumbit(event)})
      }

      getGalleryConfig(galleryType) {
          const config = {
              'main': {
                  slidesPerView: 1,
                  slidesPerGroup: 1,
                  rewind: true,
                  focusableElements: 'img',
                  pagination: {
                      el: '.swiper-pagination',
                      type: 'bullets',
                      clickable: true
                  },
                  thumbs: {
                      swiper: this.thumbnailsSlider
                  }
              },
              'thumbnails': {
                  slidesPerView: 5,
                  slidesPerGroup: 1,
                  spaceBetween: 8,
                  edgeSwipeThreshold: 0,
                  focusableElements: 'img'
              }
          }

          return config[galleryType];
      }

      async addItemToCart() {
          if (!this.productForm) return;

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.productForm);
          config.body = formData;
          
          try {
              const emptyCart = await fetch('/cart/clear.js')
              const response = await fetch(`${routes.cart_add_url}`, config)
              const data = await response.json();                
              this.sendGoogleAnalytics(data);   
              if (data) window.location.href = '/checkout';
          } catch(error) {
              console.error(error)
          }
      }

      onThumbnailClick(event, slide) {
          event.preventDefault();
          const index = +slide.dataset.index;
          if (index) this.mainSlider.slideTo(index);
      }

      onPurhaseTypeChange(event) {
          const currentPurchaseType = event.target?.value
          
          if (!this.sellingPlanInput || !currentPurchaseType) return;
          this.sellingPlanInput.disabled = currentPurchaseType == 'onetime'
      }

      onSumbit(event) {
          event.preventDefault();          
          this.addItemToCart();
      }

      sendGoogleAnalytics({final_price,id,product_title,product_type,quantity}) {                         
          const dataLayerItem = {
            event: "add_to_cart",
            ecommerce: {
              currency: Shopify.currency.active || "USD",
              value: (final_price / 100),
              items: [
                {
                  item_name: product_title,
                  item_id: id,
                  price: (final_price / 100),
                  quantity: quantity,
                  item_category: product_type || ""
                }
              ]
            }
          };
                  
          const event = new CustomEvent('analytics-custom:subscribe', {
            bubbles: true,
            detail: { dataLayerItem,type: "add_to_cart" }
          });          
          document.dispatchEvent(event);
        }
  }
  
  window.customElements.define('featured-product', FeaturedProduct)
})